
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { UserRoles } from './utils';

export const RoleFilterBlock = ({ roleFilter, setRoleFilter, lngsltd }) => {
    return (
        <FormControl fullWidth className="pb-2 mt-2" size="small">
            <InputLabel>{lngsltd["Search by Role"]}</InputLabel>
            <Select
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
                label={lngsltd["Search by Role"]}
            >
                <MenuItem value="" disabled>
                    --{lngsltd["Search by Role"]}--
                </MenuItem>
                {UserRoles.map((role, index) => (
                    <MenuItem key={index} value={role}>
                        {role}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
